import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { orderBy } from 'lodash';
import { Article, Interview } from '../../components/index';
import { get } from '../../redux/modules/interviews';

class Services extends PureComponent {

  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const { interviews: { values: { interviews = [], articles = [] }, isFetching } } = this.props;
    if (isFetching) {
      return <div/>
    }

    return (
      <div className="main events container">
        <div className="row">
          {
            interviews.length > 0 &&
            <div className="col-md-12">
              <h2>Entrevistas</h2>
              {
                interviews.map((obj, index) => {
                  return (
                    <div className="row" key={index}>
                      <div className="col-md-12">
                        <Interview {...obj}/>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          }
        </div>

        <div className="row">
          <div className="col-md-12">
            <h2>Artigos</h2>
            <div className="events__news row">
              {
                articles.map((obj, index) => {
                  return (
                    <div className={'col-lg-4 col-md-6 col-xs-12'} key={index}>
                      <Article {...obj}/>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      interviews: state.interviews
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(Services);




// WEBPACK FOOTER //
// ./src/containers/news/index.js